import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  Modal,
  FormCheck,
} from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import { formatMoney } from "./utils/useIntersection";
import CustomModal from "./CustomModal";
import { useLocation } from "react-router-dom";
import { states } from "./utils/state";
import { counties } from "./utils/counties";
import axios from "axios";

window.recaptchaOptions = {
  removeOnUnmount: true,
};
let widgetId = null;

function formatPhoneNumber(phoneNumber) {
  const cleaned = `${phoneNumber}`.replace(/\D/g, "");
  let formatted = cleaned;
  if (cleaned.length === 11 && cleaned[0] === "1") {
    formatted = cleaned.slice(1); // Remove the leading '1'
  }
  if (formatted.length === 10) {
    const match = formatted.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  }
  return phoneNumber;
}
const OfferRangeCalculator = () => {
  const [isSignUpReCaptchaDone, setIsSignUpReCaptchaDone] = useState(false);
  const formikRef = useRef();

  const [showPopup, setShowPopup] = useState({
    title: "",
    is: false,
    msg: "",
  });
  const [showCustomPopup, setShowCustomPopup] = useState({
    title: "",
    is: false,
    msg: "",
  });

  const handleCloseCustomPopup = () => {
    setShowCustomPopup({
      title: "",
      is: false,
      msg: "",
    });
  };

  const location = useLocation();

  const baseURL = process.env.REACT_APP_SIGNUP_URL?.split("/users")[0];
  const shareLoanOfferURL = `${baseURL}/util/share-loan-offer`;
  const financeCalculatorURL = `${baseURL}/util/finance-calculator`;

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const MIN_RATE = 18;
  const MAX_RATE = 22;

  const calculateOffer = ({ months, payment, fv }) => {
    const { py, cy, timing } = { py: "12", cy: "12", timing: "end" };
    const N = parseFloat(months);
    const PMT = parseFloat(payment);
    const FV = parseFloat(fv || 0);
    const P_Y = parseFloat(py);
    const C_Y = parseFloat(cy);
    const atBeginning = timing === "beginning" ? 1 : 0;

    if (isNaN(N) || isNaN(PMT) || isNaN(FV) || isNaN(P_Y) || isNaN(C_Y)) return;

    const calcPV = (rate) => {
      const r = rate / 100 / C_Y;
      const pv =
        PMT * ((1 - Math.pow(1 + r, -N)) / r) * (1 + r * atBeginning) +
        FV / Math.pow(1 + r, N);
      return pv;
    };

    const maxOffer = calcPV(MIN_RATE);
    const minOffer = calcPV(MAX_RATE);

    setShowPopup({
      title: "Confirmation!",
      is: true,
      msg: (
        <div className="text-center">
          <p>Your Loan is Worth Between</p>
          <div style={{ marginTop: "10px", fontWeight: "bold" }}>
            {formatMoney(minOffer)} to {formatMoney(maxOffer)}
          </div>
        </div>
      ),
    });
  };

  const phoneRegExp =
    /^(\+1|1)?[-.\s]?(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;

  const validationSchema = Yup.object({
    userEmail: Yup.string()
      .email("Enter Valid email Address")
      .required("Email is required"),
    name: Yup.string().required("Name is required"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(phoneRegExp, "Phone number is not valid"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      userEmail: "",
      phoneNumber: "",
      isAgree: false,
    },
    validationSchema,
    onSubmit: (formValues) => {
      shareLoanOffer(formValues);
    },
  });
  function formatPhoneNumberForAPI(phoneNumber) {
    const cleanedNumber = phoneNumber.replace(/\D/g, "");
    return cleanedNumber.startsWith("1")
      ? `+${cleanedNumber}`
      : `+1${cleanedNumber}`;
  }
  const {
    touched,
    errors,
    getFieldProps,
    handleBlur,
    handleSubmit,
    values,
    handleChange,
    isSubmitting,
    setSubmitting,
    setFieldValue,
    resetForm,
  } = formik;

  const shareLoanOffer = (formValues) => {
    const {
      months,
      payment,
      fv,
      interestRate,
      name,
      userEmail,
      phoneNumber,
      salePrice,
      financedAmount,
      downPayment,
      currentUnpaidBalance,
      initialLoanTerm,
      currentStatus,
      state,
      county,
      propertyType,
      loanType,
      purchasedProperty,
      soldProperty,
      lenderPolicyPlace,
      lienPosition,
      note,
    } = formValues || {};

    axios(shareLoanOfferURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: {
        shareLoanOffer: {
          name,
          email: userEmail,
          phoneNumber: formatPhoneNumberForAPI(phoneNumber) || "",
          propertyAddress: "",
          salePrice: salePrice,
          downPayment: downPayment,
          financedAmount: financedAmount,
          currentUnpaidBalance: currentUnpaidBalance,
          monthlyPaymentAmount: payment,
          interestRate: interestRate,
          initialLoanTerm: initialLoanTerm,
          currentStatus,
          state,
          county,
          country: "USA",
          propertyType,
          typeOfLoan: loanType,
          obtainedTitleCommitmentWhenPurchased: purchasedProperty,
          obtainedTitleCommitmentWhenSold: soldProperty,
          isLenderPolicyInPlace: lenderPolicyPlace,
          numberOfPayments: months,
          futureValue: fv,
          lienPosition,
          note: note,
          periodsPerYear: 12,
          interestCompoundPerYear: 12,
          paymentDueBeginning: false,
        },
      },
    })
      .then(async (res) => {
        if (formikRef?.current) {
          formikRef?.current?.resetForm();
        }
        setSubmitting(false);
        handlePopupClose();
        setShowCustomPopup({
          ...showPopup,
          title: "Confirmation!",
          is: true,
          size: "lg",
          buttonTitle: "Ok",
          msg: [
            `Great! One of our trusted note buyers will be in touch with you shortly. Reach out to`,
            <a
              href="mailto:Support@TerraNotes.com"
              style={{ color: "green", marginLeft: "5px", marginRight: "5px" }}
            >
              support@terranotes.com
            </a>,
            `with any questions about this process`,
          ],
        });
      })
      .catch(async (error) => {
        setSubmitting(false);
        setShowCustomPopup({
          ...showPopup,
          title: "Alert",
          is: true,
          msg: error?.response?.data?.message,
        });
      });
  };

  const handlePopupClose = () => {
    if (formikRef?.current) {
      formikRef?.current?.setSubmitting(false);
    }
    resetForm();
    setSubmitting(false);
    setShowPopup({
      title: "",
      is: false,
      msg: "",
    });
  };

  const newsLetter = (formValues) => {
    formValues &&
      Object.entries(formValues).forEach(([key, value]) => {
        formik.setFieldValue(key, value);
      });
    const { months, payment, fv, interestRate, captcha_token } =
      formValues || {};
    axios(financeCalculatorURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: {
        financeCalculator: {
          noOfPayments: months,
          monthlyPaymentAmount: payment,
          futureValue: fv,
          interestRate: interestRate,
          periodsPerYear: 12,
          interestCompoundPerYear: 12,
          paymentDueBeginning: false,
          ...(captcha_token ? { captchaToken: captcha_token } : {}),
        },
      },
    })
      .then(async (res) => {
        if (formikRef?.current) {
          formikRef?.current?.setSubmitting(false);
        }
        setShowPopup({
          title: "Confirmation!",
          is: true,
          msg: (
            <div className="text-center">
              <p>Buyers Will Likely Pay Between</p>
              <h4 style={{ marginTop: "10px", fontWeight: "bold" }}>
                {formatMoney(res?.data?.offer_price_22_pct)} to{" "}
                {formatMoney(res?.data?.offer_price_18_pct)}
              </h4>
            </div>
          ),
        });
      })
      .catch(async (error) => {
        if (formikRef?.current) {
          formikRef?.current?.setSubmitting(false);
        }
        setShowCustomPopup({
          ...showPopup,
          title: "Alert",
          is: true,
          msg: error?.response?.data?.message,
        });
      });
  };

  const expiredRecaptcha = () => {
    console.log("expired");
    if (widgetId !== null) {
      window.grecaptcha.reset(widgetId);
    }
    setIsSignUpReCaptchaDone(false);
  };

  const createRecaptcha = (setFieldValue) => {
    window.grecaptcha?.ready(function () {
      widgetId = window.grecaptcha.render("captchaSignup", {
        sitekey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
        callback: (value) => {
          if (value && formikRef?.current) {
            formikRef?.current?.setFieldValue("captcha_token", value);
            setIsSignUpReCaptchaDone(true);
          }
        },
        "expired-callback": expiredRecaptcha,
        "error-callback": function (e) {
          setIsSignUpReCaptchaDone(false);
        },
      });
    });
  };

  const hideRechaptcha =
    window.location.origin.includes("dev") ||
    window.location.origin.includes("localhost");

  useEffect(() => {
    if (!hideRechaptcha) {
      createRecaptcha();
    }
  }, [hideRechaptcha]);

  const FormField = ({
    label,
    name,
    type = false,
    options = [],
    isDisabled = false,
  }) => (
    <div className="mb-3">
      <Row className="align-items-baseline g-2">
        <Col xs={6} lg={{ span: 5, offset: 1 }}>
          <label className="mb-0">{label}</label>
        </Col>
        {type === "amount" ? (
          <Col xs={6}>
            <div className="input-group">
              <span className="input-group-text">$</span>
              <Field
                type="number"
                name={name}
                className="form-control"
                disabled={isDisabled}
              />
            </div>
            <div className="text-danger text-start ps-1">
              <ErrorMessage name={name} />
            </div>
          </Col>
        ) : type === "percent" ? (
          <Col xs={6}>
            <div className="input-group">
              <Field
                type="number"
                name={name}
                className="form-control"
                disabled={isDisabled}
              />
              <span className="input-group-text">%</span>
            </div>
            <div className="text-danger text-start ps-1">
              <ErrorMessage name={name} />
            </div>
          </Col>
        ) : type === "select" ? (
          <Col xs={6}>
            <Field
              as="select"
              name={name}
              className="form-select"
              disabled={isDisabled}
              style={{ height: "38px", borderRadius: "0.375rem" }}
            >
              <option value="">Select</option>
              {options?.map((val) =>
                typeof val === "string" ? (
                  <option value={val}>{val}</option>
                ) : (
                  <option value={val?.value}>{val?.label}</option>
                )
              )}
            </Field>
            <div className="text-danger text-start ps-1">
              <ErrorMessage name={name} />
            </div>
          </Col>
        ) : type === "text" ? (
          <Col xs={6}>
            <Field
              type="text"
              name={name}
              className="form-control"
              disabled={isDisabled}
            />
            <div className="text-danger text-start ps-1">
              <ErrorMessage name={name} />
            </div>
          </Col>
        ) : (
          <Col xs={6}>
            <Field
              type="number"
              name={name}
              className="form-control"
              disabled={isDisabled}
            />
            <div className="text-danger text-start ps-1">
              <ErrorMessage name={name} />
            </div>
          </Col>
        )}
      </Row>
    </div>
  );

  const TitleInfoForm = ({ values, handleChange }) => (
    <div className="m-1" style={{ margin: "-12px" }}>
      {/* Purchased Property */}
      <BootstrapForm.Group
        as={Row}
        className="mb-3"
        controlId="purchasedProperty"
      >
        <BootstrapForm.Label column sm={12}>
          Did you obtain a title commitment when you purchased this property?
        </BootstrapForm.Label>

        <Col sx={12} md={6}>
          <Field
            as="select"
            name="purchasedProperty"
            className="form-select"
            style={{ height: "38px", borderRadius: "0.375rem" }}
          >
            <option value="">Select</option>
            {[
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" },
            ]?.map((val) => (
              <option value={val?.value}>{val?.label}</option>
            ))}
          </Field>
          <div className="text-danger text-start ps-1">
            <ErrorMessage name="purchasedProperty" />
          </div>
        </Col>
      </BootstrapForm.Group>

      {/* Sold Property */}
      <BootstrapForm.Group as={Row} className="mb-3" controlId="soldProperty">
        <BootstrapForm.Label column sm={12}>
          Did you obtain a title commitment when you sold this property?
        </BootstrapForm.Label>
        <Col sx={12} md={6}>
          <Field
            as="select"
            name="soldProperty"
            className="form-select"
            style={{ height: "38px", borderRadius: "0.375rem" }}
          >
            <option value="">Select</option>
            {[
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" },
            ]?.map((val) => (
              <option value={val?.value}>{val?.label}</option>
            ))}
          </Field>
          <div className="text-danger text-start ps-1">
            <ErrorMessage name="soldProperty" />
          </div>
        </Col>
      </BootstrapForm.Group>

      {/* Lender Policy Place */}
      <BootstrapForm.Group
        as={Row}
        className="mb-3"
        controlId="lenderPolicyPlace"
      >
        <BootstrapForm.Label column sm={12}>
          Is there a lender’s policy in place?
        </BootstrapForm.Label>
        <Col sx={12} md={6}>
          <Field
            as="select"
            name="lenderPolicyPlace"
            className="form-select"
            style={{ height: "38px", borderRadius: "0.375rem" }}
          >
            <option value="">Select</option>
            {[
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" },
            ]?.map((val) => (
              <option value={val?.value}>{val?.label}</option>
            ))}
          </Field>
          <div className="text-danger text-start ps-1">
            <ErrorMessage name="lenderPolicyPlace" />
          </div>
        </Col>
      </BootstrapForm.Group>

      <BootstrapForm.Group as={Row} className="mb-3" controlId="note">
        <BootstrapForm.Label column sm={12}>
          Is there anything else we should know about this loan?
        </BootstrapForm.Label>
        <Col sx={12} md={6}>
          <Field type="text" name="note" className="form-control" />
        </Col>
        <Col sm={12}>
          <ErrorMessage name="note" component="div" className="text-danger" />
        </Col>
      </BootstrapForm.Group>
    </div>
  );

  return (
    <div
      id="loanWorthSection"
      style={{
        backgroundImage: `url("/images/12141.jpg")`, // Corrected the image path
        backgroundSize: "cover",
        padding: "10vh 2vh",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        boxShadow: "0 0 0 20000px rgba(255, 255, 255, 0.45) inset", // Corrected the boxShadow property
      }}
    >
      <Container className="mb-5">
        <h1 className="text-success text-center my-4">Get Cash Offer</h1>
        <Row className="justify-content-center pt-4">
          <Col xs={12} md={10} lg={9}>
            <Card className="shadow-lg w-100 px-3 px-md-4">
              <Formik
                innerRef={formikRef}
                initialValues={{
                  months: "",
                  payment: "",
                  fv: "0",
                  salePrice: "",
                  financedAmount: "",
                  downPayment: "",
                  interestRate: "",
                  currentUnpaidBalance: "",
                  initialLoanTerm: "",
                  currentStatus: "",
                  state: "",
                  county: "",
                  propertyType: "",
                  loanType: "",
                  lienPosition: "",
                  purchasedProperty: "",
                  soldProperty: "",
                  lenderPolicyPlace: "",
                  note: "",
                  captcha_token: "",
                }}
                validationSchema={Yup.object({
                  months: Yup.number()
                    .required("Number of periods is required")
                    .min(
                      1,
                      "Number of periods must be greater than or equal to 1"
                    ),
                  payment: Yup.number()
                    .required("Periodic Payment is required")
                    .min(
                      0.01,
                      "Periodic Payment must be greater than or equal to 0.01"
                    ),
                  fv: Yup.number()
                    .required("Future Value is required")
                    .min(0, "Can't be negative"),

                  financedAmount: Yup.number()
                    .required("Financed Amount is required")
                    .min(
                      0.01,
                      "Financed Amount must be greater than or equal to 0.01"
                    ),

                  interestRate: Yup.number()
                    .required("Interest Rate is required")
                    .min(1, "Interest Rate must be greater than or equal to 1"),
                  currentUnpaidBalance: Yup.number()
                    .required("Current Unpaid Balance is required")
                    .min(
                      0.01,
                      "Current Unpaid Balance must be greater than or equal to 0.01"
                    ),
                  initialLoanTerm: Yup.number()
                    .required("Initial Loan Term is required")
                    .min(
                      1,
                      "Initial Loan Term must be greater than or equal to 1"
                    ),
                  currentStatus: Yup.string().required(
                    "Current Status selection is required"
                  ),
                  state: Yup.string().required("State selection is required"),
                  county: Yup.string().required("County selection is required"),
                  lienPosition: Yup.string().required(
                    "Lien Position is required"
                  ),
                  propertyType: Yup.string().required(
                    "Property Type is required"
                  ),
                  loanType: Yup.string().required("Loan Type is required"),
                  purchasedProperty: Yup.string(),
                  soldProperty: Yup.string(),
                  lenderPolicyPlace: Yup.string(),
                })}
                onSubmit={newsLetter}
              >
                {({
                  resetForm,
                  values,
                  handleChange,
                  dirty,
                  setFieldValue,
                  isSubmitting,
                }) => (
                  <Form className="px-2">
                    <Card
                      className="bg-light mb-4 my-0 m-md-3 px-2 py-3 p-lg-4"
                      style={{ margin: "-24px" }}
                    >
                      <FormField
                        label="Number of Payments Remaining"
                        name="months"
                      />

                      <FormField
                        label="Monthly Payment Amount (P&I)"
                        name="payment"
                        type="amount"
                      />
                      <FormField
                        label="Balloon Payment Amount (if applicable)"
                        name="fv"
                        type="amount"
                      />
                    </Card>

                    <h6 className="text-center fw-bold">
                      Additional Information
                    </h6>
                    <hr className="border border-light-subtle" />

                    <div className="my-3">
                      <Row className="align-items-baseline gx-4">
                        {[
                          {
                            name: "salePrice",
                            type: "amount",
                            label: "Sales Price",
                          },
                          {
                            name: "downPayment",
                            type: "amount",
                            label: "Down Payment",
                          },
                          {
                            name: "financedAmount",
                            type: "amount",
                            label: "Financed Amount",
                          },
                          {
                            name: "currentUnpaidBalance",
                            type: "amount",
                            label: "Current Unpaid Balance",
                          },
                          {
                            name: "interestRate",
                            type: "percent",
                            label: "Interest Rate",
                          },
                          {
                            name: "initialLoanTerm",
                            type: "number",
                            label: "Initial Loan Term ",
                          },
                          {
                            name: "currentStatus",
                            type: "select",
                            label: "Current Status",
                            options: [
                              { value: "Current", label: "Current" },
                              { value: "GracePeriod", label: "GracePeriod" },
                              { value: "Late", label: "Late" },
                              { value: "Default", label: "Default" },
                            ],
                          },
                          {
                            name: "state",
                            type: "select",
                            label: "State",
                            options: states || [],
                          },
                          {
                            name: "county",
                            type: "select",
                            label: "County",
                            options: counties[values?.state],
                          },
                          {
                            name: "propertyType",
                            type: "text",
                            label: "Property Type",
                          },
                          {
                            name: "lienPosition",
                            type: "select",
                            label: "Lien Position",
                            options: [
                              { value: "1", label: "1st" },
                              { value: "2", label: "2nd" },
                              { value: "3", label: "3rd" },
                              { value: "4", label: "4th" },
                              { value: "5", label: "5th" },
                            ],
                          },
                          {
                            name: "loanType",
                            type: "select",
                            label: "Loan Type",
                            options: [
                              {
                                value: "Deed of Trust",
                                label: "Deed of Trust",
                              },
                              { value: "Mortgage", label: "Mortgage" },
                              {
                                value: "Contract for Deed",
                                label: "Contract for Deed",
                              },
                              { value: "Hard Money", label: "Hard Money" },
                              { value: "Other", label: "Other" },
                            ],
                          },
                        ]?.map((row) => (
                          <Col xs={12} lg={6} className="px-0 px-lg-2">
                            <FormField
                              label={row?.label}
                              name={row?.name}
                              type={row?.type}
                              options={row?.options}
                            />
                          </Col>
                        ))}
                      </Row>

                      <TitleInfoForm
                        values={values}
                        handleChange={handleChange}
                      />
                    </div>
                    <div className="py-2">
                      {!hideRechaptcha && <div id="captchaSignup" />}
                      <div className="text-end py-2">
                        <Button
                          variant="secondary"
                          type="button"
                          onClick={() => {
                            resetForm();
                          }}
                          className="m-2 fw-bold"
                        >
                          Clear
                        </Button>
                        <Button
                          disabled={!isSignUpReCaptchaDone && !hideRechaptcha}
                          type="submit"
                          variant="success"
                          className="px-5 fs-5 fw-bold"
                        >
                          {isSubmitting ? (
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          ) : (
                            "Get Cash Offer"
                          )}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Col>
        </Row>
        <Modal
          show={showPopup?.is}
          onHide={handlePopupClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <>
              <div className="card-header text-center justify-content-center">
                <h3 className="text-success">Confirmation!</h3>
              </div>

              <div className="card-body p-1 p-lg-4">
                <h5 className="text-center justify-content-center text-muted">
                  {showPopup?.msg}
                  <p className="py-3">
                    {" "}
                    Would you like to receive a firm cash offer?
                  </p>
                </h5>

                <div className="mt-2">
                  <div className="row gx-3">
                    <div className="col-md-4 mb-2">
                      <label className="mb-1">Name</label>
                      <input
                        className="form-control my-1"
                        id="name"
                        type="text"
                        placeholder="Smith"
                        {...getFieldProps("name")}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.name && errors.name ? (
                        <div className="text-danger small">{errors.name}</div>
                      ) : null}
                    </div>
                    <div className="col-md-5 mb-2">
                      <label className="mb-1 ">Email</label>
                      <input
                        className="form-control my-1"
                        id="userEmail"
                        type="email"
                        aria-describedby="emailHelp"
                        placeholder="JohnSmith@LandCompany.com"
                        {...getFieldProps("userEmail")}
                        value={values.userEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.userEmail && errors.userEmail ? (
                        <div className="text-danger small">
                          {errors.userEmail}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-md-3 mb-2">
                      <label className="mb-1 ">Phone Number</label>
                      <input
                        className="form-control my-1"
                        id="phoneNumber"
                        type="tel"
                        placeholder="(123) 456-7890"
                        {...getFieldProps("phoneNumber")}
                        value={formatPhoneNumber(values.phoneNumber)}
                        onChange={(e) => {
                          const rawValue = e.target.value.replace(/\D/g, "");
                          setFieldValue("phoneNumber", rawValue);
                        }}
                        onBlur={handleBlur}
                      />
                      {touched.phoneNumber && errors.phoneNumber ? (
                        <div className="text-danger small">
                          {errors.phoneNumber}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-12 my-3">
                    <FormCheck
                      type="checkbox"
                      id="agreeCheckbox"
                      label={
                        <span
                          style={{
                            textAlign: "left",
                            display: "block",
                            marginBottom: "-5px",
                          }}
                        >
                          <p className="">
                            {" "}
                            I understand my loan and contact information will be
                            shared with potential note buyers
                          </p>
                        </span>
                      }
                      checked={values?.isAgree}
                      onChange={(e) =>
                        setFieldValue("isAgree", e.target.checked)
                      }
                    />
                  </div>
                  <div className="col-md-12 my-3 text-center text-danger">
                    This offer range is best for performing, active loans. If
                    loan is non performing or in default, final offer may be
                    outside of this range.
                  </div>
                </div>
              </div>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button
                  className="btn text-success  btn-block fs-6 fw-bold "
                  onClick={() => {
                    handlePopupClose();
                  }}
                >
                  Cancel
                </button>
                <Button
                  type="button"
                  variant="success"
                  disabled={!values?.isAgree}
                  className="px-5 fw-bold"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  {isSubmitting ? (
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Get Cash Offer"
                  )}
                </Button>
              </div>
            </>
          </Modal.Body>
        </Modal>
        <CustomModal
          showModal={showCustomPopup}
          handleClose={handleCloseCustomPopup}
        />
      </Container>
    </div>
  );
};

export default OfferRangeCalculator;
